import { styled, Typography, TypographyProps } from "@mui/material";

export const SectionTitle = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    fontWeight: 600,
    fontSize: "16px",
    color: "#999999",
  })
);
